import React, { useState } from 'react';

type SidebarContextType = {
  expanded: boolean;
  setExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  toggleSidebar: () => void;
  expandedTeams: Record<string, boolean>;
  setExpandedTeams: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
  toggleTeam: (teamId: string) => void;
};

export const SidebarContext = React.createContext<SidebarContextType | null>(null);

export const SidebarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [expanded, setExpanded] = useState(false);
  const [expandedTeams, setExpandedTeams] = useState<Record<string, boolean>>({});

  const toggleSidebar = () => {
    setExpanded(!expanded);
  };

  const toggleTeam = (teamId: string) => {
    setExpandedTeams({
      ...expandedTeams,
      [teamId]: !expandedTeams[teamId]
    });
  };

  return (
    <SidebarContext.Provider value={{ 
      expanded, 
      setExpanded, 
      toggleSidebar,
      expandedTeams,
      setExpandedTeams,
      toggleTeam
    }}>
      {children}
    </SidebarContext.Provider>
  );
};
